"use client";

import { forwardRef } from "react";

interface OptionButtonProps {
  label: string;
  keyHint: "1" | "2";
  selected: boolean;
  onClick: () => void;
}

export const OptionButton = forwardRef<HTMLButtonElement, OptionButtonProps>(
  function OptionButton({ label, keyHint, selected, onClick }, ref) {
    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        aria-pressed={selected}
        className={[
          "relative flex w-full items-center justify-between rounded-[14px] px-5",
          "h-16 text-left text-base font-medium text-white transition-all duration-150",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-pulse-500 focus-visible:ring-offset-2 focus-visible:ring-offset-black",
          selected
            ? "border-2 border-pulse-500 bg-pulse-500/10"
            : "border border-white/10 bg-white/5 hover:border-pulse-500",
        ].join(" ")}
      >
        <span>{label}</span>
        <span className="flex items-center gap-2">
          {selected && (
            <span
              aria-hidden="true"
              className="bg-pulse-500 h-2.5 w-2.5 rounded-full"
            />
          )}
          <span
            aria-hidden="true"
            className="hidden items-center justify-center rounded-[5px] border border-white/20 px-1.5 py-0.5 text-[11px] font-medium text-white/40 md:flex"
          >
            {keyHint}
          </span>
        </span>
      </button>
    );
  }
);
